/* eslint-disable lines-between-class-members */
// @flow
import baseService from '../landrover/business/service/base.service'

export default class SAASService extends baseService {
  constructor () {
    // 初始化行为
    super()
    this.baseUrl = {
      dev: '/api',
      gqc: '',
      prd: ''
    }
  }

  setup () {
    // 启动行为
    return super.setup()
  }

  // 业务接口务按照下列方法来书写
  //
  // /**
  //  * 实例接口
  //
  //  * @param {string} exampleParam1
  //  * @param {number} exampleParam2
  //  * @returns {Promise<exampleResponse>}
  //  * @memberof SAASService
  //  */
  // exampleRequest(exampleParam1: string, exampleParam2: number): Promise<exampleResponse> {
  //   return this.request(
  //     'cgi/examplePath',
  //     'GET',
  //     {
  //       exampleParam1,
  //       exampleParam2
  //     }
  //   )
  // }

  /**
   * 获取职位列表.
   * @param {string} search_city 城市搜索
   * @param {string} search_value 职位/公司搜索
   */
  getJobListRequest ({
    page,
    per_page = 10,
    search_city,
    search_jd_ids,
    search_value,
    job_types,
    publish_date_from,
    degree_ids,
    monthly_salary_begin,
    monthly_salary_end,
    workyear_from,
    workyear_to,
    advantages,
    recruitment_type,
    category_path
  }) {
    return this.request('/cow/jd/index', 'POST', {
      page,
      per_page,
      search_city,
      search_jd_ids,
      search_value,
      job_types,
      publish_date_from,
      degree_ids,
      monthly_salary_begin,
      monthly_salary_end,
      workyear_from,
      workyear_to,
      advantages,
      recruitment_type,
      category_path
    })
  }

  /**
   * 获取推荐职位列表.
   * @param {string} search_city 城市搜索
   * @param {string} search_value 职位/公司搜索
   */
  getRecommendJobList ({ page, per_page = 10, search_city, search_value }) {
    return this.request('/cow/jd/recommend_list', 'GET', {
      page,
      per_page,
      search_city,
      search_value
    })
  }

  /**
   * 获取短信验证码.
   * @param {*} phone
   */
  createVCode (phone) {
    return this.request('/cow/account/send_vcode', 'GET', {
      phone
    })
  }

  /**
   * 登录
   * @param {*} name
   * @param {*} password
   */
  login (phone, vcode) {
    return this.request('/cow/account/sign_in', 'GET', {
      phone,
      vcode
    })
  }

  /**
   * 退出登录
   */
  logOut () {
    return this.request('/cow/account/login_out', 'GET', {})
  }

  /**
   * 获取职位详情
   * @param {*} jd_id
   */
  getJobDetailsRequest (jd_id) {
    return this.request('/cow/jd/show', 'GET', {
      jd_id
    })
  }

  /**
   * 获取公司信息.
   */
  getClientInfo () {
    return this.request('/cow/company/info', 'GET', {})
  }

  /**
   * 投递记录.
   */
  getRecordsRequest ({ page = 1, per_page = 999 }) {
    return this.request('/cow/delivery_records/index', 'GET', { page, per_page })
  }

  /**
   * 获取简历.
   */
  getCvRequest () {
    return this.request('/cow/cv/show', 'GET')
  }

  /**
   * 简历是否完善.
   */
  resumeIsComplete () {
    return this.request('/cow/cv/check_complete', 'GET')
  }
  /**
   * 投递.
   */
  postDeliver ({ jd_id }) {
    return this.request('/cow/jd/delivery', 'GET', { jd_id })
  }

  /**
   * 保存简历基本信息.
   */
  saveBasicInfo (data) {
    return this.request('/cow/cv/store', 'POST', data)
  }
  /**
   * 保存简历教育、工作经历.
   */
  postWorkOrEducationInfo (data) {
    return this.request('/cow/cv/store/one', 'POST', data)
  }
  /**
   * 保存简历suoyouziduan.
   */
  storeAllField (data) {
    return this.request('/cow/cv/store/all', 'POST', data)
  }

  /**
   * 删除简历模块区域.
   */
  deleteModule (data) {
    return this.request('/cow/cv/destroy', 'POST', data)
  }

  /**
   * 域名认证（自定义微信分享）.
   */
  getWxSdk (url, priority_use_http_referer = 1) {
    return this.request('/common/wechat/js_sdk', 'GET', {
      url,
      priority_use_http_referer
    })
  }

  /**
   * 雇主详情
   */
  fetchEmployeeList (params) {
    return this.request('/cow/client/index', 'GET', params)
  }

  /**
   * 雇主详情
   */
  fetchEmployeeInfo (client_id) {
    return this.request('/cow/client/info', 'GET', {
      client_id
    })
  }

  /**
   * 雇主职位列表
   */

  fetchEmployeeJdList (data) {
    return this.request('/cow/client/jd_list', 'GET', data)
  }

  /**
   * 获取资讯列表
   * @param {*} {page, per_page}
   */

  fetchInformationList (data) {
    return this.request('/cow/information/list', 'GET', data)
  }

  /**
   * 获取资讯详情
   * @param {*} id
   */
  fetchInformationDetail (id) {
    return this.request('/cow/information/show', 'GET', {
      id
    })
  }

  /**
   * 外网登录（用户名密码）.
   * @param {Number} channel_id
   * @param {String} username
   * @param {String} password
   */
  loginExternalNetworkByAccount (username, password, channel_id) {
    return this.request('/common/grab_resume/add_task_by_account', 'POST', {
      username,
      password,
      channel_id
    })
  }

  /**
   * 外网简历解析记录查询.
   * @param {Number} task_id
   */
  parseExternalResume (task_id) {
    return this.request('/common/grab_resume/get_task_result', 'POST', { task_id })
  }

  // 点击职位分享次数
  setShareRecord () {
    return this.request('/cow/jd/share_record', 'GET')
  }

  // 分享页面浏览次数
  setShareVisit () {
    return this.request('/cow/jd/share_visit', 'GET')
  }

  // pv记录
  setPVStore () {
    return this.request('/cow/pv/store', 'GET')
  }
}
